import * as Common from "@tfo/common"
import { useEffect } from "react"
import { useHistory, useParams,  } from "react-router-dom"
import RootStore from "../stores/RootStore"
import { useStore } from "./useStore"

export function useReportStore<T extends RootStore>() {

    const { clientViewStore, login } = useStore<T>()
    const { orderId } = useParams<{ orderId: string }>()
    const { deliveryId } = useParams<{ deliveryId: string }>()
    const history = useHistory();

    useEffect(() => {
        if (orderId) {
            //If valid backOffice cookie then login here with backOffice cookie
            if (Common.utils.loggedIn(Common.utils.BACKOFFICE_COOKIE)) {
                login(Common.utils.BACKOFFICE_COOKIE)
            }
            clientViewStore.reportStore.fetchOrder(Number(orderId))
        }
        else if(deliveryId){
            clientViewStore.getOrderIdByDeliveryId(deliveryId).then(response => {
                const convertedOrderId = response.orderId as string
                clientViewStore.reportStore.fetchOrder(Number(convertedOrderId))
            //eslint-disable-next-line 
            }).catch(_ => {
                history.push('/archive')
            })
        }
    }, [orderId])
    
    return clientViewStore
}